import moment from 'moment';
import {View} from 'react-big-calendar';

export const CALENDAR = {
  momentFormat: 'YYYY-MM-DD',
  calendarFormat: 'MMMM YYYY',
  monthPickerFormat: 'MMMM',
  yearPickerFormat: 'YYYY',
  convertMonthToCalendarFormat: 'MM',
  minDate: moment().format('YYYY-MM-DD'),
  maxDate: '2030-12-31',
  homeFormat: 'DD MMMM YYYY',
};

function generateArrayOfYears() {
  var min = new Date().getFullYear() - 5;
  var max = min + 10;
  var years = [];

  for (var i = min; i <= max; i++) {
    years.push(String(i));
  }
  return years;
}

export const bigCalendarViewConfig: View[] = ['month', 'week', 'day'];

export const YEARS = generateArrayOfYears();

const d = new Date().setUTCHours(0, 0, 0, 0);
export const INITIAL_DATE = new Date(d).toISOString();

export const generateAWeekRangeForPicker = (startDate: string) => {
  const initalEndDate = moment(startDate).subtract(-7, 'days').toISOString();

  return initalEndDate;
};
